import './yeargroup.css'
import yearGroupIcon from '../../assets/yearlevel.svg'

const Yeargroupbuttons = ({ onClick, selectedYeargroup, region }) => {
    const yearData = {
        UK: [
          "Year 1",
          "Year 2",
          "Year 3",
          "Year 4",
          "Year 5",
          "Year 6",
          "Year 7",
          "Year 8",
          "Year 9",
          "Year 10 (GCSE Start)",
          "Year 11 (GCSE Exams Year)"
        ],
        US: [
          "Kindergarten",
          "Grade 1",
          "Grade 2",
          "Grade 3",
          "Grade 4",
          "Grade 5",
          "Grade 6",
          "Grade 7",
          "Grade 8",
          "Grade 9 (Freshman)",
          "Grade 10 (Sophomore)"
        ]
      };

   // Adapt label depending on region
   const labelText = region === "UK" ? "Year Group" : "Grade Level";

   return (
       <div className="yeargroup-box">
           <label htmlFor="yearGroup" className="form-label">
               <img 
                   src={yearGroupIcon} 
                   alt="info" 
                   style={{ width: '16px', height: '16px' }} 
               />{" "}
               {labelText}
           </label>

           <select
               id="yearGroup"
               value={selectedYeargroup || ''}
               onChange={(e) => onClick(e.target.value)}
               className="yeargroup-dropdown"
           >
               <option value="" disabled>
                   {region === "UK" ? "Select a Year Group" : "Select a Grade Level"}
               </option>
               {yearData[region].map((yeargroup, index) => (
                   <option key={index} value={yeargroup}>
                       {yeargroup}
                   </option>
               ))}
           </select>
       </div>
   );
};

export default Yeargroupbuttons;